<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
    </teleport>

    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="max-w-screen-2xl m-auto">
            <Alert v-if="show_error_form" :dismissable="true" @close="show_error_form = false"
                   class="bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50">
                Correggi gli errori di inserimento
            </Alert>
            <div class="py-10 flex justify-between items-center">
                <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
                <div class="flex">
                    <NextButton variant="outline-secondary" @click="$router.back()"
                                class="w-48 hidden text-sm sm:block py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                    <NextButton variant="primary" @click="save"
                                class="w-48 text-sm sm:block py-2 px-4 ml-3">Salva <i class="spinner"></i>
                    </NextButton>
                </div>
            </div>

            <h3 class="text-3xl font-bold mb-6">Nuovo fornitore</h3>

            <div class="pb-6">
                <Field field_name="Denominazione" :required="!anagraficheAutocomplete.selection"
                       :errors="getErrors('anagrafica_denominazione_id')">
                    <VueMultiselect
                        v-model="anagraficheAutocomplete.selection"
                        :options="anagraficheAutocomplete.options"
                        :taggable="true"
                        :clear-on-select="false"
                        :preserveSearch="true"
                        @tag="(value)=>anagraficheAutocomplete.add({id:-1, denominazione:value})"
                        placeholder="Denominazione"
                        tagPlaceholder="Crea nuova denominazione"
                        class="next-vue-multiselect-single"
                        track-by="id"
                        label="denominazione"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="anagraficheAutocompleteSarch">
                        <template v-slot:option="{option}">

                            <div class="flex flex-col text-sm p-3"
                                 :class="getDenominazioneOptionColor(option)">
                                <template v-if="option.isTag">
                                    <span>Aggiungi denominazione: <span
                                        class="font-bold">{{ option.label }}</span></span>
                                </template>
                                <template v-else>
                                    <div class="flex items-center justify-between">
                                        <div class="flex flex-col">

                                        <span>Denominazione: <span
                                            class="font-bold">{{ option.denominazione }}</span></span>
                                            <span>Ragione sociale: <span
                                                class="font-bold">{{ option.ragione_sociale }}</span></span>
                                            <span>Partita IVA: <span
                                                class="font-bold">{{ option.partita_iva }}</span></span>
                                            <span>CF: <span class="font-bold">{{ option.codice_fiscale }}</span></span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </VueMultiselect>
                </Field>
            </div>


            <div class="grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Anagrafica gamma</h6>

                <div v-if="hasPermission('set id_gamma')" class="flex flex-col pb-3 grow">
                    <Field field_name="ID gamma" type="number"
                           :errors="getErrors('id_gamma')">
                        <div class="relative flex items-center">
                            <input v-model="fornitore_model.id_gamma" type="number"
                                   class="p-2 bg-next-gray-md-dark hover:bg-white w-full pr-7">
                            <Spinner v-show="anagrafica_gamma_loading" class="w-5 absolute right-1 "></Spinner>
                        </div>
                    </Field>
                </div>

                <div v-if="anagrafica_gamma?.CG16_CODICE" class="flex flex-col pb-3 col-span-2">
                    <span>Ragione sociale: {{ anagrafica_gamma.CG16_RAGSOANAG }}</span>
                    <span>Partita IVA: {{ anagrafica_gamma.CG16_PARTIVA }}</span>
                    <span>Codice fiscale: {{ anagrafica_gamma.CG16_CODFISCALE }}</span>
                </div>
                <div v-else class="pb-3">
                    <span>Azienda gamma non associata</span>
                </div>
            </div>

            <AnagraficaAzienda
                :errors="errors"
                @update:azienda_id="onUpdateAziendaId"
                :disable_dati_azienda="disable_dati_azienda"
                :disable_autocomplete_azienda="disable_autocomplete_azienda"
                v-model:azienda_id="fornitore_model.azienda_id"
                v-model:place_id="fornitore_model.a_place_id"
                v-model:lat="fornitore_model.a_lat"
                v-model:lng="fornitore_model.a_lng"
                v-model:estera="fornitore_model.estera"
                v-model:tipo="fornitore_model.tipo"
                v-model:partita_iva="fornitore_model.partita_iva"
                v-model:codice_fiscale="fornitore_model.codice_fiscale"
                v-model:ragione_sociale="fornitore_model.ragione_sociale"
                v-model:sede_legale_nazione_id="fornitore_model.sede_legale_nazione_id"
                v-model:sede_legale_provincia_id="fornitore_model.sede_legale_provincia_id"
                v-model:sede_legale_comune_id="fornitore_model.sede_legale_comune_id"
                v-model:sede_legale_regione_estero="fornitore_model.sede_legale_regione_estero"
                v-model:sede_legale_citta_estero="fornitore_model.sede_legale_citta_estero"
                v-model:sede_legale_via="fornitore_model.sede_legale_via"
                v-model:sede_legale_cap="fornitore_model.sede_legale_cap"
                v-model:sede_legale_numero="fornitore_model.sede_legale_numero"
            >
            </AnagraficaAzienda>

            <AnagraficaDenominazione
                :errors="errors"
                :disabled="disable_dati_denominazione"
                v-model:anagrafica_denominazione_id="fornitore_model.anagrafica_denominazione_id"
                v-model:denominazione="fornitore_model.denominazione"
                v-model:sito="fornitore_model.sito"
                v-model:gruppo_di_appartenenza="fornitore_model.gruppo_di_appartenenza"
                v-model:place_id="fornitore_model.place_id"
                v-model:lat="fornitore_model.lat"
                v-model:lng="fornitore_model.lng"
                v-model:sede_operativa_via="fornitore_model.sede_operativa_via"
                v-model:sede_operativa_numero="fornitore_model.sede_operativa_numero"
                v-model:sede_operativa_nazione_id="fornitore_model.sede_operativa_nazione_id"
                v-model:sede_operativa_cap="fornitore_model.sede_operativa_cap"
                v-model:sede_operativa_regione_estero="fornitore_model.sede_operativa_regione_estero"
                v-model:sede_operativa_citta_estero="fornitore_model.sede_operativa_citta_estero"
                v-model:sede_operativa_provincia_id="fornitore_model.sede_operativa_provincia_id"
                v-model:sede_operativa_comune_id="fornitore_model.sede_operativa_comune_id"
                v-model:email="fornitore_model.email"
                v-model:pec="fornitore_model.pec"
                v-model:telefono_1="fornitore_model.telefono_1"
                v-model:telefono_2="fornitore_model.telefono_2"
                v-model:fax="fornitore_model.fax"
            >
                <div class="flex items-end justify-center mb-3">
                    <NextButton @click="copiaDaSedeLegale" class="w-50 p-3">Copia dati dalla sede legale</NextButton>
                </div>
            </AnagraficaDenominazione>


            <div class="pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">IBAN</h6>

                <IbanForm v-model:ibans="fornitore_model.ibans" :errors="errors"></IbanForm>
            </div>
            <div class="grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Assegnazioni
                    fornitore</h6>

                <div class="flex flex-col">
                    <Field field_name="Settore merceologico" :required="true" v-model="settoriSelections"
                           :errors="getErrors('settori_merceologici')">
                        <VueMultiselect
                            :searchable="true"
                            :internal-search="false"
                            :multiple="true"
                            trackBy="id"
                            label="descrizione"
                            @search-change="settore_merceologico_autocomplete.search"
                            v-model="settore_merceologico_autocomplete.selection"
                            :options="settore_merceologico_autocomplete.options"
                            :close-on-select="false" :clear-on-select="false"
                            placeholder="Settore"
                            deselectLabel="Deseleziona"
                            selectedLabel="Selezionato"
                            selectLabel="Seleziona"
                            class="next-vue-multiselect"
                        >
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    {{ option.descrizione }}
                                </MultiselectOption>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col" v-if="hasPermission('approve fornitori')">
                    <Field field_name="Qualifica" :required="true" v-model="fornitore_model.qualifica"
                           :errors="getErrors('qualifica')">
                        <VueMultiselect
                            :searchable="true"
                            :internal-search="false"
                            :multiple="false"
                            trackBy="id"
                            label="text"
                            @search-change="qualifica_autocomplete.search"
                            v-model="qualifica_autocomplete.selection"
                            :options="qualifica_autocomplete.options"
                            :close-on-select="true" :clear-on-select="true"
                            placeholder="Qualifica"
                            deselectLabel="Deseleziona"
                            selectedLabel="Selezionato"
                            selectLabel="Seleziona"
                            class="next-vue-multiselect-single"
                        >
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col">
                    <Field field_name="Accordo quadro"
                           :errors="getErrors('quadro_file_id')">
                        <div class="flex items-start">
                            <Checkbox
                                class="pt-3"
                                checkClass="h-4 w-4"
                                :checked="fornitore_model.accordo_quadro"
                                @change="fornitore_model.accordo_quadro = !fornitore_model.accordo_quadro"
                                for_id="quadro">
                            </Checkbox>

                            <FileUpload
                                v-model:uploaded_files="uploaded_quadro"
                                v-model:model_files="allegati_quadro"
                                v-model:to_delete="to_delete_quadro"
                                accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                            >
                                <template v-slot:default="{props, methods}">
                                    <div :class="{'invisible': !fornitore_model.accordo_quadro}"
                                         class="flex flex-col grow">
                                        <NextButton variant="outline-secondary" @click="methods.open"
                                                    class="w-full h-10 px-4 grow mb-2">
                                            <i class="icon icon-graffetta"></i> Allega
                                        </NextButton>
                                        <div class="grid grid-cols-1 gap-3">
                                            <div v-show="uploaded_quadro.length">
                                                <span>Nuovo: </span>
                                                <a class="underline text-sm text-next-atp"
                                                   v-for="(f,idx) in uploaded_quadro">
                                                    <span>{{ f.name }}</span>
                                                </a>
                                            </div>
                                            <div>
                                                <span>Attualmente presente: </span>
                                                <a class="underline text-sm text-next-atp mb-1"
                                                   v-for="(f,idx) in allegati_quadro">
                                                    <span>{{ f.name }}</span>
                                                </a>
                                            </div>
                                        </div>
                                        <small v-for="(e,i) in props.errors" :key="i"
                                               class="text-next-orange">{{ e.join(', ') }}</small>
                                    </div>
                                </template>
                            </FileUpload>
                        </div>
                    </Field>
                </div>
            </div>

            <div class="grid grid-cols-3 gap-3 mb-3 pt-3">
                <div v-show="requiredPolizze" class="grow flex">
                    <FileUpload
                        v-model:uploaded_files="uploaded_polizze"
                        v-model:model_files="allegati_polizze"
                        v-model:to_delete="to_delete_polizze"
                        multiple
                        accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                    >
                        <template v-slot:default="{props, methods}">
                            <div class="flex flex-col grow gap-3">
                                <h3 class="font-bold justify-self-start">Polizza RCT/O</h3>
                                <div class="flex flex-col grow justify-end gap-3">
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in allegati_polizze" :key="`a_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in uploaded_polizze_to_save" :key="`u_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_polizze" :key="`la_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_polizze_to_save" :key="`las_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                </div>
                                <NextButton variant="outline-secondary" @click="polizze_visible=true"
                                            class="w-full h-10 px-4">
                                    <i class="icon icon-graffetta"></i> Allega
                                </NextButton>
                            </div>
                            <Modal :visible="polizze_visible" :backdrop="true">
                                <template #main>
                                    <div v-show="!uploaded_polizze.length" class="flex flex-col mb-5">
                                        <Field field_name="Link" v-model="polizze_link"></Field>
                                        <small v-for="(e,i) in props.errors" :key="i"
                                               class="text-next-orange">{{ e.join(', ') }}</small>
                                        <small v-for="(e,i) in polizze_errors" :key="i"
                                               class="text-next-orange">{{ e }}</small>
                                    </div>
                                    <div v-show="!polizze_link.length" class="flex flex-col mb-5">
                                        <NextButton v-if="!uploaded_polizze.length" variant="outline-secondary"
                                                    @click="methods.open"
                                                    class="w-full h-10 px-4">
                                            <i class="icon icon-graffetta"></i> Allega
                                        </NextButton>
                                        <template v-else>
                                            <Field v-for="(f,idx) in uploaded_polizze" :key="`u_${idx}`"
                                                   field_name="Allegato" v-model="f.name"
                                                   :input-attrs="{disabled:true}"></Field>
                                        </template>
                                    </div>
                                </template>
                                <template #footer>
                                    <div class="flex flex-col gap-3">
                                        <NextButton variant="primary" @click="salvaPolizze"
                                                    class="w-full h-10 px-4">Salva
                                        </NextButton>
                                        <NextButton variant="outline-primary" @click="methods.reset();chiudiPolizze()"
                                                    class="w-full h-10 px-4">Chiudi
                                        </NextButton>
                                    </div>
                                </template>
                            </Modal>

                        </template>
                    </FileUpload>
                </div>
                <div v-show="requiredVisure" class="grow flex">
                    <FileUpload
                        v-model:uploaded_files="uploaded_visure"
                        v-model:model_files="allegati_visure"
                        v-model:to_delete="to_delete_visure"
                        multiple
                        accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                    >
                        <template v-slot:default="{props, methods}">
                            <div class="flex flex-col grow gap-3">
                                <h3 class="font-bold justify-self-start">Visura</h3>
                                <div class="flex flex-col grow justify-end gap-3">
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in allegati_visure" :key="`a_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in uploaded_visure_to_save" :key="`u_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_visure" :key="`la_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_visure_to_save" :key="`las_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                </div>
                                <NextButton variant="outline-secondary" @click="visure_visible=true"
                                            class="w-full h-10 px-4">
                                    <i class="icon icon-graffetta"></i> Allega
                                </NextButton>
                            </div>
                            <Modal :visible="visure_visible" :backdrop="true">
                                <template #main>
                                    <div v-show="!uploaded_visure.length" class="flex flex-col mb-5">
                                        <Field field_name="Link" v-model="visure_link"></Field>
                                        <small v-for="(e,i) in props.errors" :key="i"
                                               class="text-next-orange">{{ e.join(', ') }}</small>
                                        <small v-for="(e,i) in visure_errors" :key="i"
                                               class="text-next-orange">{{ e }}</small>
                                    </div>
                                    <div v-show="!visure_link.length" class="flex flex-col mb-5">
                                        <NextButton v-if="!uploaded_visure.length" variant="outline-secondary"
                                                    @click="methods.open"
                                                    class="w-full h-10 px-4">
                                            <i class="icon icon-graffetta"></i> Allega
                                        </NextButton>
                                        <template v-else>
                                            <Field v-for="(f,idx) in uploaded_visure" :key="`u_${idx}`"
                                                   field_name="Allegato" v-model="f.name"
                                                   :input-attrs="{disabled:true}"></Field>
                                        </template>
                                    </div>

                                </template>
                                <template #footer>
                                    <div class="flex flex-col gap-3">
                                        <NextButton variant="primary" @click="salvaVisure"
                                                    class="w-full h-10 px-4">Salva
                                        </NextButton>
                                        <NextButton variant="outline-primary" @click="methods.reset();chiudiVisure()"
                                                    class="w-full h-10 px-4">Chiudi
                                        </NextButton>
                                    </div>
                                </template>
                            </Modal>

                        </template>
                    </FileUpload>
                </div>
                <div v-show="requiredAlbi" class="grow flex">
                    <FileUpload
                        v-model:uploaded_files="uploaded_albo"
                        v-model:model_files="allegati_albo"
                        v-model:to_delete="to_delete_albo"
                        multiple
                        accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                    >
                        <template v-slot:default="{props, methods}">
                            <div class="flex flex-col grow gap-3">
                                <h3 class="font-bold justify-self-start">Iscrizione albo gestori</h3>
                                <div class="flex flex-col grow justify-end gap-3">
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in allegati_albo" :key="`a_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       v-for="(f,idx) in uploaded_albo_to_save" :key="`u_${idx}`">
                                        <i class="icon icon-graffetta"></i> <span>{{ f.name }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_albo" :key="`la_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                    <a class="underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3"
                                       :href="f.url"
                                       v-for="(f,idx) in links_albo_to_save" :key="`las_${idx}`">
                                        <span>{{ f.url }}</span>
                                    </a>
                                </div>
                                <NextButton variant="outline-secondary" @click="albo_visible=true"
                                            class="w-full h-10 px-4">
                                    <i class="icon icon-graffetta"></i> Allega
                                </NextButton>
                            </div>
                            <Modal :visible="albo_visible" :backdrop="true">
                                <template #main>
                                    <div v-show="!uploaded_albo.length" class="flex flex-col mb-5">
                                        <Field field_name="Link" v-model="albo_link"></Field>
                                        <small v-for="(e,i) in props.errors" :key="i"
                                               class="text-next-orange">{{ e.join(', ') }}</small>
                                        <small v-for="(e,i) in albi_errors" :key="i"
                                               class="text-next-orange">{{ e }}</small>
                                    </div>
                                    <div v-show="!albo_link.length" class="flex flex-col mb-5">
                                        <NextButton v-if="!uploaded_albo.length" variant="outline-secondary"
                                                    @click="methods.open"
                                                    class="w-full h-10 px-4">
                                            <i class="icon icon-graffetta"></i> Allega
                                        </NextButton>
                                        <template v-else>
                                            <Field v-for="(f,idx) in uploaded_albo" :key="`u_${idx}`"
                                                   field_name="Allegato" v-model="f.name"
                                                   :input-attrs="{disabled:true}"></Field>
                                        </template>
                                        <small v-for="(e,i) in albi_errors" :key="i"
                                               class="text-next-orange">{{ e }}</small>
                                    </div>
                                </template>
                                <template #footer>
                                    <div class="flex flex-col gap-3">
                                        <NextButton variant="primary" @click="salvaAlbo"
                                                    class="w-full h-10 px-4">Salva
                                        </NextButton>
                                        <NextButton variant="outline-primary" @click="methods.reset();chiudiAlbo()"
                                                    class="w-full h-10 px-4">Chiudi
                                        </NextButton>
                                    </div>
                                </template>
                            </Modal>

                        </template>
                    </FileUpload>
                </div>
            </div>

            <div class="flex flex-col mb-3">
                <div class="pb-2 font-bold text-sm">Note</div>
                <div class="flex justify-self-start bg-white">
                    <NextEditor v-model="fornitore_model.note"></NextEditor>
                </div>
            </div>

            <div class="flex justify-end pt-3">
                <NextButton variant="primary" @click="save"
                            class="w-48 text-sm sm:block py-2 px-4 ml-3">Salva <i class="spinner"></i>
                </NextButton>
            </div>
        </div>

    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import {Paths} from "@/types";
import {nuovo_fornitore} from "@/BreadcrumbsPath";
import fornitoriManager from "../api/FornitoriManager";
import Autocomplete from "@/setup/Autocomplete";
import settoriMerceologiciManager from "../api/SettoriMerceologiciManager";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Loading from "@/components/Loading.vue";
import aziendeManager from "../api/Aziende";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import NextEditor from "@/components/NextEditor.vue";
import FileUpload from "@/components/FileUpload.vue";
import Modal from "@/components/Modal.vue";
import linksManager from "../api/LinkManager";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import qualificheManager from "../api/QualificaManager";
import Checkbox from "@/components/Checkbox.vue";
import Spinner from "@/components/Spinner.vue";
import {mapGetters} from 'vuex';
import anagraficaGamma from "../api/AnagraficaGamma";
import Alert from "@/components/Alert.vue";
import Select from "@/components/Select.vue";
import anagraficheManager from "../api/Denominazioni";
import IbanForm from "@/components/IbanForm.vue";
import MapViewer from "@/components/Address/MapViewer.vue";
import AnagraficaAzienda from "@/views/Anagrafica/AnagraficaAzienda.vue";
import AnagraficaDenominazione from "@/views/Anagrafica/AnagraficaDenominazione.vue";

@Options({
    name: 'NuovoFornitore',
    components: {
        AnagraficaDenominazione,
        AnagraficaAzienda,
        MapViewer,
        IbanForm,
        Select,
        Alert,
        Spinner,
        Checkbox,
        Modal,
        FileUpload,
        Loading,
        MultiselectOption,
        Breadcrumbs,
        Field,
        NextButton,
        NextEditor,
    },
    inject: ['downloadFile'],
    computed: {
        ...mapGetters([
            'isNewBusiness',
            'hasPermission',
            'me',
        ])
    },
})
export default class NuovoFornitore extends Vue {

    aziendaAutocomplete: any = setup(() => Autocomplete(aziendeManager))
    anagraficheAutocomplete: any = setup(() => Autocomplete(anagraficheManager))

    tipo_options = [
        {id: 0, text: 'Privato'},
        {id: 1, text: 'Pubblico'},
    ]
    tipo_model: any = null

    id!: number | string
    loading = false
    visible = false
    cm_visible = -1
    to_delete_quadro = []
    allegati_quadro: any[] = []
    uploaded_quadro: any[] = []


    to_delete_polizze = []
    allegati_polizze = []
    uploaded_polizze = []
    uploaded_polizze_to_save = []
    polizze_visible = false
    polizze_link = ''

    to_delete_visure = []
    allegati_visure = []
    uploaded_visure = []
    uploaded_visure_to_save = []
    visure_visible = false
    visure_link = ''

    to_delete_albo = []
    allegati_albo = []
    uploaded_albo = []
    uploaded_albo_to_save = []
    albo_visible = false
    albo_link = ''

    links_albo = []
    links_visure = []
    links_polizze = []

    links_albo_to_save: any[] = []
    links_visure_to_save: any[] = []
    links_polizze_to_save: any[] = []

    polizze_errors: any = {}
    visure_errors: any = {}
    albi_errors: any = {}

    getDenominazioneOptionColor(option: any) {
        //se l'anagrafica ha già il cliente
        if (option.cliente_id) {
            return 'bg-green-500 bg-opacity-30'
        } else {
            //se esiste l'anagrafica denominazione ma non il cliente
            if (option.id) {
                return 'bg-red-300 bg-opacity-30'
            }
        }
    }

    get requiredPolizze() {
        return this.settore_merceologico_autocomplete.selection.some((e: any) => e.polizza)
    }

    get requiredVisure() {
        return this.settore_merceologico_autocomplete.selection.some((e: any) => e.visura)
    }

    get requiredAlbi() {
        return this.settore_merceologico_autocomplete.selection.some((e: any) => e.albo_gestori)
    }

    hasPermission!: (perm: string) => void

    anagrafica_gamma: any = {}
    anagrafica_gamma_loading = false

    fornitore_model: any = {
        estera: false,
        tipo: -1,
        denominazione: null,
        anagrafica_denominazione_id: null,
        azienda_id: null,
        partita_iva: null,
        ragione_sociale: null,
        codice_fiscale: null,
        sito: null,
        sede_legale_via: null,
        sede_legale_numero: null,
        sede_legale_cap: null,
        sede_legale_comune_id: null,
        sede_legale_provincia_id: null,
        sede_legale_nazione_id: null,
        sede_legale_regione_estero: null,
        sede_legale_citta_estero: null,
        sede_operativa_via: null,
        sede_operativa_numero: null,
        sede_operativa_cap: null,
        sede_operativa_comune_id: null,
        sede_operativa_provincia_id: null,
        sede_operativa_nazione_id: null,
        sede_operativa_regione_estero: null,
        sede_operativa_citta_estero: null,
        gruppo_di_appartenenza: null,
        email: null,
        pec: null,
        qualifica: null,
        note: null,
        lat: null,
        lng: null,
        place_id: null,
        a_lat: null,
        a_lng: null,
        a_place_id: null,
        accordo_quadro: false,
        allegati_albo: [],
        allegati_polizze: [],
        allegati_visure: [],
        settori_merceologici: [],
        aziende_gruppo: [],
        ibans: [{
            iban: null,
            descrizione: null
        }]
    }

    disable_dati_azienda = false
    disable_autocomplete_azienda = false
    disable_dati_denominazione = false

    settore_merceologico_autocomplete: any = setup(() => Autocomplete(settoriMerceologiciManager, true))
    qualifica_autocomplete: any = setup(() => Autocomplete(qualificheManager, false))

    settoriSelections = []
    show_error_form = false
    id_gamma_search_timeout = 0

    get getBreadcrumbsPath(): Paths[] {
        return nuovo_fornitore
    }

    anagraficheAutocompleteSarch($event: any, timeout = 500) {
        this.anagraficheAutocomplete.search($event, timeout).then(() => {
            this.anagraficheAutocomplete.options.map((e: any) => {
                if (e.fornitore_id) {
                    e['$isDisabled'] = true
                }
            })
        })
    }

    onUpdateAziendaId($event: any) {
        // se event non è null o -1 allora disabilito i dati azienda
        this.disable_dati_azienda = !!($event && $event > 0);
    }

    copiaDaSedeLegale() {
        this.fornitore_model.place_id = this.fornitore_model.a_place_id
        this.fornitore_model.lat = this.fornitore_model.a_lat
        this.fornitore_model.lng = this.fornitore_model.a_lng
        this.fornitore_model.sede_operativa_via = this.fornitore_model.sede_legale_via
        this.fornitore_model.sede_operativa_numero = this.fornitore_model.sede_legale_numero
        this.fornitore_model.sede_operativa_cap = this.fornitore_model.sede_legale_cap
        this.fornitore_model.sede_operativa_comune_id = this.fornitore_model.sede_legale_comune_id
        this.fornitore_model.sede_operativa_provincia_id = this.fornitore_model.sede_legale_provincia_id
        this.fornitore_model.sede_operativa_nazione_id = this.fornitore_model.sede_legale_nazione_id
        this.fornitore_model.sede_operativa_regione_estero = this.fornitore_model.sede_legale_regione_estero
        this.fornitore_model.sede_operativa_citta_estero = this.fornitore_model.sede_legale_citta_estero
    }

    @Watch('aziendaAutocomplete.options')
    addOption() {
        if (this.aziendaAutocomplete.searchValue === '') return
        this.aziendaAutocomplete.options.unshift({
            id: -1,
            label: this.aziendaAutocomplete.searchValue,
            isTag: true
        })
    }

    @Watch('anagraficheAutocomplete.selection')
    anagrafica(new_value: any, old: any) {
        if (new_value) {
            if (new_value.id > 0) {
                this.disable_autocomplete_azienda = true
                this.disable_dati_denominazione = true
                this.fornitore_model.azienda_id = new_value?.azienda_id ?? null
                this.fornitore_model.anagrafica_denominazione_id = new_value.id
            } else {
                this.disable_autocomplete_azienda = false
                this.disable_dati_denominazione = false
                this.fornitore_model.anagrafica_denominazione_id = -1
                this.fornitore_model.denominazione = new_value?.denominazione

            }
        } else {
            this.disable_autocomplete_azienda = false
            this.disable_dati_denominazione = false
            this.fornitore_model.anagrafica_denominazione_id = null
        }
    }

    created() {
        this.qualifica_autocomplete.search('', 0)
        this.settore_merceologico_autocomplete.search('', 0)
        this.qualifica_autocomplete.retrieve(0) // imposto il default
        if (!this.id) {
            this.tipo_model = this.tipo_options[0]
        }
    }

    errors = {}

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    @Watch('tipo_model')
    tipo(new_value: any, old: any) {
        this.fornitore_model.tipo = new_value.id
    }

    @Watch('settore_merceologico_autocomplete.selection')
    committente(new_value: any, old: any) {
        this.fornitore_model.settori_merceologici = new_value.map((e: any) => e.id)
    }

    @Watch('qualifica_autocomplete.selection')
    qualifica(new_value: any, old: any) {
        this.fornitore_model.qualifica = new_value.id
    }

    @Watch('fornitore_model.id_gamma', {deep: true})
    id_gamma(new_value: any, old: any) {
        if (this.id_gamma_search_timeout > 0) {
            clearTimeout(this.id_gamma_search_timeout);
            this.id_gamma_search_timeout = 0
        }
        if (new_value) {
            this.anagrafica_gamma_loading = true
            // @ts-ignore
            this.id_gamma_search_timeout = setTimeout(() => {
                anagraficaGamma.clienteGamma(new_value).then((response: any) => {
                    this.anagrafica_gamma = response.data
                }).finally(() => {
                    this.anagrafica_gamma_loading = false
                })
            }, 500)
        } else {
            this.anagrafica_gamma = {}
        }
    }

    save() {
        this.loading = true
        this.fornitore_model.allegati_albo = this.allegati_albo.map((e: any) => e.id).concat(this.uploaded_albo_to_save.map((e: any) => e.id))
        this.fornitore_model.allegati_visure = this.allegati_visure.map((e: any) => e.id).concat(this.uploaded_visure_to_save.map((e: any) => e.id))
        this.fornitore_model.allegati_polizze = this.allegati_polizze.map((e: any) => e.id).concat(this.uploaded_polizze_to_save.map((e: any) => e.id))

        this.fornitore_model.links_albo = this.links_albo.map((e: any) => e.id).concat(this.links_albo_to_save.map((e: any) => e.id))
        this.fornitore_model.links_visure = this.links_visure.map((e: any) => e.id).concat(this.links_visure_to_save.map((e: any) => e.id))
        this.fornitore_model.links_polizze = this.links_polizze.map((e: any) => e.id).concat(this.links_polizze_to_save.map((e: any) => e.id))

        // se ho effettivamente caricato dei file li uploado
        if (this.uploaded_quadro.length) {
            this.fornitore_model.quadro_file_id = this.uploaded_quadro.pop()?.id || null
        }

        fornitoriManager.fornitoreCreate(this.fornitore_model).then((res) => {
            this.errors = {}
            this.show_error_form = false
            //@ts-ignore
            this.$router.replace({name: 'DettaglioFornitore', params: {fid: res.data.id}})
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
                this.show_error_form = true
            }
        }).finally(() => {
            this.loading = false
        })
    }

    chiudiPolizze() {
        this.uploaded_polizze.splice(0)
        this.polizze_visible = false
        this.polizze_link = ''
        this.polizze_errors = {}
    }

    resetpPolizze() {
        this.polizze_visible = false
        this.polizze_link = ''
        this.polizze_errors = {}
    }

    salvaPolizze() {
        if (this.polizze_link) {
            linksManager.polizzaLinkCreate({links: [this.polizze_link]}).then((res: any) => {
                this.links_polizze_to_save.push(...res.data)
                this.resetpPolizze()
            }).catch((res) => {
                if (res.response.status == 422) {
                    this.polizze_errors = res.response.data.errors
                }
            })

        } else {
            this.uploaded_polizze_to_save.push(...this.uploaded_polizze.splice(0))
            this.resetpPolizze()
        }
    }

    chiudiVisure() {
        this.uploaded_visure.splice(0)
        this.visure_visible = false
        this.visure_link = ''
        this.visure_errors = {}
    }

    resetVisure() {
        this.visure_visible = false
        this.visure_link = ''
        this.visure_errors = {}
    }

    salvaVisure() {
        if (this.visure_link) {
            linksManager.visureLinkCreate({links: [this.visure_link]}).then((res: any) => {
                this.links_visure_to_save.push(...res.data)
                this.resetVisure()
            }).catch((res) => {
                if (res.response.status == 422) {
                    this.visure_errors = res.response.data.errors
                }
            })
        } else {
            this.uploaded_visure_to_save.push(...this.uploaded_visure.splice(0))
            this.resetVisure()
        }
    }

    chiudiAlbo() {
        this.uploaded_albo.splice(0)
        this.albo_visible = false
        this.albo_link = ''
        this.albi_errors = {}
    }

    resetAlbi() {
        this.albo_visible = false
        this.albo_link = ''
        this.albi_errors = {}
    }

    salvaAlbo() {
        if (this.visure_link) {
            linksManager.albiLinkCreate({links: [this.albo_link]}).then((res: any) => {
                this.links_albo_to_save.push(...res.data)
                this.resetAlbi()
            }).catch((res) => {
                if (res.response.status == 422) {
                    this.albi_errors = res.response.data.errors
                }
            })
        } else {
            this.uploaded_albo_to_save.push(...this.uploaded_albo.splice(0))
            this.resetAlbi()
        }
    }

}

</script>


<style lang="scss">

</style>
